/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Clever Analytics Notifications Public API
 * OpenAPI spec version: 1.0.0
 */
import { notificationsInstance } from '../../api/client.ts';
export type WebNotificationToType = typeof WebNotificationToType[keyof typeof WebNotificationToType];


export const WebNotificationToType = {
  TEST: 'TEST',
  NEW_REPORT: 'NEW_REPORT',
  PAYMENT_WAITING: 'PAYMENT_WAITING',
  PAYMENT_RENEW_WAITING: 'PAYMENT_RENEW_WAITING',
  PAYMENT_COMPLETED: 'PAYMENT_COMPLETED',
  SUBSCRIPTION_CANCELLED: 'SUBSCRIPTION_CANCELLED',
  SUBSCRIPTION_EXPIRED: 'SUBSCRIPTION_EXPIRED',
} as const;

export interface WebNotificationTo {
  id: number;
  title: string;
  body: string;
  image?: string;
  type: WebNotificationToType;
  archivedAt?: string;
  createdAt: string;
}

export type NotificationRequestType = typeof NotificationRequestType[keyof typeof NotificationRequestType];


export const NotificationRequestType = {
  TEST: 'TEST',
  NEW_REPORT: 'NEW_REPORT',
  PAYMENT_WAITING: 'PAYMENT_WAITING',
  PAYMENT_RENEW_WAITING: 'PAYMENT_RENEW_WAITING',
  PAYMENT_COMPLETED: 'PAYMENT_COMPLETED',
  SUBSCRIPTION_CANCELLED: 'SUBSCRIPTION_CANCELLED',
  SUBSCRIPTION_EXPIRED: 'SUBSCRIPTION_EXPIRED',
} as const;

export interface NotificationRequest {
  type: NotificationRequestType;
}

export type NewReportNotificationRequest = NotificationRequest & {
  /** @minLength 1 */
  title: string;
  /** @minLength 1 */
  body: string;
  /** @minLength 1 */
  link: string;
  /**
     * @minLength 2
     * @maxLength 2
     */
  language: string;
  image?: string;
};

export interface NotificationAttachmentRequest {
  data: string;
  fileName: string;
  contentType: string;
}

export type PaymentCompletedNotificationRequestPeriod = typeof PaymentCompletedNotificationRequestPeriod[keyof typeof PaymentCompletedNotificationRequestPeriod];


export const PaymentCompletedNotificationRequestPeriod = {
  MONTHLY: 'MONTHLY',
  QUARTERLY: 'QUARTERLY',
  YEARLY: 'YEARLY',
} as const;

export type PaymentCompletedNotificationRequest = NotificationRequest & {
  /** @minLength 1 */
  userId: string;
  /** @minLength 1 */
  language: string;
  /**
     * @minLength 2
     * @maxLength 2
     */
  country: string;
  /** @minLength 1 */
  product: string;
  /** @minLength 1 */
  billingEmail: string;
  /** @minLength 1 */
  amountTotal: string;
  /** @minLength 1 */
  amountCurrency: string;
  period: PaymentCompletedNotificationRequestPeriod;
  paidAt: string;
  /** @minLength 1 */
  invoiceUrl: string;
  invoice: NotificationAttachmentRequest;
};

export type PaymentRenewWaitingNotificationRequestPeriod = typeof PaymentRenewWaitingNotificationRequestPeriod[keyof typeof PaymentRenewWaitingNotificationRequestPeriod];


export const PaymentRenewWaitingNotificationRequestPeriod = {
  MONTHLY: 'MONTHLY',
  QUARTERLY: 'QUARTERLY',
  YEARLY: 'YEARLY',
} as const;

export type PaymentRenewWaitingNotificationRequest = NotificationRequest & {
  /** @minLength 1 */
  userId: string;
  /** @minLength 1 */
  language: string;
  /**
     * @minLength 2
     * @maxLength 2
     */
  country: string;
  /** @minLength 1 */
  product: string;
  /** @minLength 1 */
  billingEmail: string;
  /** @minLength 1 */
  bankSubject: string;
  /** @minLength 1 */
  bankName: string;
  /** @minLength 1 */
  bankIban: string;
  /** @minLength 1 */
  bankSwift: string;
  /** @minLength 1 */
  bankAccount: string;
  /** @minLength 1 */
  variable: string;
  /** @minLength 1 */
  amountTotal: string;
  /** @minLength 1 */
  amountCurrency: string;
  period: PaymentRenewWaitingNotificationRequestPeriod;
  /** @minLength 1 */
  invoiceUrl: string;
  invoiceDueDate: string;
  invoice: NotificationAttachmentRequest;
};

export type PaymentWaitingNotificationRequestPeriod = typeof PaymentWaitingNotificationRequestPeriod[keyof typeof PaymentWaitingNotificationRequestPeriod];


export const PaymentWaitingNotificationRequestPeriod = {
  MONTHLY: 'MONTHLY',
  QUARTERLY: 'QUARTERLY',
  YEARLY: 'YEARLY',
} as const;

export type PaymentWaitingNotificationRequest = NotificationRequest & {
  /** @minLength 1 */
  userId: string;
  /** @minLength 1 */
  language: string;
  /**
     * @minLength 2
     * @maxLength 2
     */
  country: string;
  /** @minLength 1 */
  product: string;
  /** @minLength 1 */
  billingEmail: string;
  /** @minLength 1 */
  bankSubject: string;
  /** @minLength 1 */
  bankName: string;
  /** @minLength 1 */
  bankIban: string;
  /** @minLength 1 */
  bankSwift: string;
  /** @minLength 1 */
  bankAccount: string;
  /** @minLength 1 */
  variable: string;
  /** @minLength 1 */
  amountTotal: string;
  /** @minLength 1 */
  amountCurrency: string;
  period: PaymentWaitingNotificationRequestPeriod;
  /** @minLength 1 */
  invoiceUrl: string;
  invoiceDueDate: string;
  invoice: NotificationAttachmentRequest;
};

export type SubscriptionCancelledNotificationRequest = NotificationRequest & {
  /** @minLength 1 */
  userId: string;
  /** @minLength 1 */
  language: string;
  /**
     * @minLength 2
     * @maxLength 2
     */
  country: string;
  /** @minLength 1 */
  product: string;
  /** @minLength 1 */
  email: string;
  expiresAt: string;
};

export type SubscriptionExpiredNotificationRequest = NotificationRequest & {
  /** @minLength 1 */
  userId: string;
  /** @minLength 1 */
  language: string;
  /**
     * @minLength 2
     * @maxLength 2
     */
  country: string;
  /** @minLength 1 */
  product: string;
  /** @minLength 1 */
  email: string;
};

export type TestUserNotificationRequest = NotificationRequest & {
  /** @minLength 1 */
  userId: string;
  /** @minLength 1 */
  language: string;
  /**
     * @minLength 2
     * @maxLength 2
     */
  country: string;
  /** @minLength 1 */
  email: string;
};

export type PushCreateRequestPlatform = typeof PushCreateRequestPlatform[keyof typeof PushCreateRequestPlatform];


export const PushCreateRequestPlatform = {
  IOS: 'IOS',
  ANDROID: 'ANDROID',
  WEB: 'WEB',
} as const;

export interface PushCreateRequest {
  platform: PushCreateRequestPlatform;
  /** @minLength 1 */
  token: string;
}

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * @summary Archive notification by it`s ID
 */
export const archiveNotification = (
    id: number,
 options?: SecondParameter<typeof notificationsInstance<WebNotificationTo>>,) => {
      return notificationsInstance<WebNotificationTo>(
      {url: `/can-notifications/api/notification/${id}/archive`, method: 'PUT'
    },
      options);
    }

/**
 * @summary Send a notification
 */
export const sendNotification = (
    newReportNotificationRequestPaymentCompletedNotificationRequestPaymentRenewWaitingNotificationRequestPaymentWaitingNotificationRequestSubscriptionCancelledNotificationRequestSubscriptionExpiredNotificationRequestTestUserNotificationRequest: NewReportNotificationRequest | PaymentCompletedNotificationRequest | PaymentRenewWaitingNotificationRequest | PaymentWaitingNotificationRequest | SubscriptionCancelledNotificationRequest | SubscriptionExpiredNotificationRequest | TestUserNotificationRequest,
 options?: SecondParameter<typeof notificationsInstance<void>>,) => {
      return notificationsInstance<void>(
      {url: `/can-notifications/internal/api/notification`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: newReportNotificationRequestPaymentCompletedNotificationRequestPaymentRenewWaitingNotificationRequestPaymentWaitingNotificationRequestSubscriptionCancelledNotificationRequestSubscriptionExpiredNotificationRequestTestUserNotificationRequest
    },
      options);
    }

/**
 * @summary Create a new push token registration
 */
export const create = (
    pushCreateRequest: PushCreateRequest,
 options?: SecondParameter<typeof notificationsInstance<void>>,) => {
      return notificationsInstance<void>(
      {url: `/can-notifications/api/push`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pushCreateRequest
    },
      options);
    }

/**
 * @summary List all notifications for a user
 */
export const getNotifications = (

 options?: SecondParameter<typeof notificationsInstance<WebNotificationTo[]>>,) => {
      return notificationsInstance<WebNotificationTo[]>(
      {url: `/can-notifications/api/notification`, method: 'GET'
    },
      options);
    }

export type ArchiveNotificationResult = NonNullable<Awaited<ReturnType<typeof archiveNotification>>>
export type SendNotificationResult = NonNullable<Awaited<ReturnType<typeof sendNotification>>>
export type CreateResult = NonNullable<Awaited<ReturnType<typeof create>>>
export type GetNotificationsResult = NonNullable<Awaited<ReturnType<typeof getNotifications>>>
